import React, { Component, Fragment } from "react";
import "moment/locale/fr";
import _ from "lodash";

// import ImportKpi from "./ImportKpi";
import List from "../../../components/list/List";
import Pagination from "components/pagination/Pagination";
import iocsListColumn from "./IocsList.utils";

class IocsList extends Component {
  componentDidMount() {
    this.props.init("iocs");
  }

  render() {
    const { iocsList, page, pages, pageSize, nbItems, getNext } = this.props;

    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des IOCs</h2>
        </div>
        <div class="p-content-page-center-content">
          <List columns={iocsListColumn} data={iocsList} defaultText="Aucun ioc trouvé." />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
        </div>
      </div>
    );
  }
}

export default IocsList;



// WEBPACK FOOTER //
// src/containers/admin/iocs/IocsList.js